import {
  IfFalse,
  IfTrue,
  RenderWhen,
} from "../../../common/infrastructure/components/RenderWhen";
import { usePermissions } from "../../../common/infrastructure/hooks/usePermissions";
import { endpointsMetadata } from "../../../common/infrastructure/routes/endpointsMetadata";
import { Planner } from "../../planner/planner/Planner";
import { PortalCalendar } from "../../portal/calendar/PortalCalendar";

export const CalendarRouter = () => {

  const { userHavePermissions } = usePermissions();

  const hasPermissionsToPlanner = userHavePermissions(
    endpointsMetadata.planner.getAll
  );

  return (
    <RenderWhen condition={!!hasPermissionsToPlanner}>
      <IfTrue>
        <Planner />
      </IfTrue>
      <IfFalse>
        <PortalCalendar />
      </IfFalse>
    </RenderWhen>
  );
};
